import MsgEnterprise from './components/index.vue'
export default MsgEnterprise